export const exactApp = {
  id: 92,
  name: "exact",
  label: "Exact",
  useOAuth: true,
  // Renews its OAuth token through the core reauthorization endpoint
  // (apps/initializeReauthorization) instead of a direct provider redirect
  showReauthorizeButton: true,
  logo: process.env.BASE_URL + "media/shopLogos/exact.svg",
  additional_params: {
    requestHeaders: {
      "Content-Type": "application/x-www-form-urlencoded"
    },
    body: {
      grant_type: "authorization_code"
    },
    requestMethod: "POST",
    endpoint: "/api/oauth2/token"
  },
  environmentVariables: {
    oauth: {
      response_type: "code",
      client_id: process.env?.VUE_APP_EXACT_APP_CLIENT_ID,
      redirect_uri: process.env?.VUE_APP_EXACT_APP_REDIRECT_URI
    },
    presetId: process.env?.VUE_APP_SCM_APP_EXACT_PRESET_ID
  }
};
